import Error from './error';
import ErrorOld from './error-old';

export { Error, ErrorOld };
